<template>
  <vue-apex-charts
    ref="keywordsearchChartDonut"
    height="450"
    :options="chartOptionsDonut"
    :series="series"
    :totalFreq="totalFreq"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";



export default {
  name: "KeywordsearchChartDonut",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptionsDonut: {
        chart: {
          type: "donut",
        },
        labels: ['남성', '여성'],
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
        },
        tooltip: {
          enabled: false,
          y: {
            formatter(val){
              return val
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "center",
          fontSize: "16px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 20,
            vertical: 10,
          },
          markers: {
            size: 7,
            offsetX: 10,
            offsetY: 0,
            strokeWidth: 0,
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,                
                total: {
                  show:true,
                  label: "총 검색량",
                  fontSize: "22px",
                  fontWeight: "bold",
                  fontFamily: 'NanumBarunGothic, Arial, sans-serif !important',
                  formatter(w){
                    let completionSum=0;
                    return w.globals.seriesTotals.reduce((a,b,c,d)=>{
                      completionSum= d[0]+d[1]
                      return completionSum.toLocaleString();
                    },0)
                  }
                },
                value: {
                  show: true,
                  formatter(val){
                    return parseFloat(val).toLocaleString()
                  }
                }
              },
            },
          },
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
      },
      
      series: [],

      totalFreq: "0"
    };
  },
  props: {
    donutChartData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    donutChartData() {
      this.series = []
      for (const data of this.donutChartData) {
        this.series.push(data);
      }
      this.$refs.competitionChartDonut.updateOptions({
        series: [{
          data: this.series
        }]
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
